import list from './list'
import edit from './edit'
import icon from '@material-ui/icons/Person'

const broadcasters = { list, edit, icon, options: { label: 'Promises' } }

export default broadcasters
